import { type SearchValues, useAssignQueryParameter, useUpdateQueryParams } from '@pba/react-router';
import type {
  OnboardingTourStepOption,
  UpdateOnboardingTourStepOptionHandler,
  UpdateOnboardingTourStepOptionHandlerOptions,
} from 'models';
import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';
import { StepParameter } from './StepParameter';

type P = {
  stepKey?: string;
};

const defaultProps: P = { stepKey: 'step' } as const;

export const useOnboardingTourStep = ({ stepKey = 'step' }: P = defaultProps): {
  onChangeStep: UpdateOnboardingTourStepOptionHandler;
  step?: OnboardingTourStepOption;
} => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { state } = useLocation();
  const updateQueryParams = useUpdateQueryParams();
  const { assignValue: setStep, value: step } = useAssignQueryParameter(stepKey, StepParameter);

  const onChangeStep = useCallback(
    ({ replace, step: nextStep }: UpdateOnboardingTourStepOptionHandlerOptions) => {
      const urlUpdates: SearchValues = {};
      setStep({ newValue: nextStep, object: urlUpdates });
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      updateQueryParams({ navigateOptions: { replace, state }, urlUpdates });
    },
    [setStep, state, updateQueryParams],
  );

  return useMemo(
    () => ({
      onChangeStep,
      step,
    }),
    [step, onChangeStep],
  );
};
